export default "__VITE_ASSET__BAFZ1Lex__"